import React, {  } from "react";
import { Typography, Box } from "@mui/joy";
import { PageTitle } from "../../../components";

const InfoPage = () => {

    // useEffect(() => {
    //     toast.success('Welcome')
    // },[])
    return (
            <Box>
                <PageTitle title={'Bank Infomartions'} />

                <Typography>
                    All Infomartions will be shown here
                </Typography>
            </Box>





    )
}

export default InfoPage